/**
 * Returns a URL-friendly version of a string by removing all accents, converting to
 * lowercase, and replacing spaces with hyphens.
 *
 * @param {...(string | number)[]} args - The strings or numbers to be slugified.
 * @returns {string} - The slugified string.
 */
export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ')

  return value
    .normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-') // separator
}
